const BASE_URL = "https://medizen.ir/scs";

export const ENDPOINTS = {
  SERVICES: `${BASE_URL}/getServices`,
  BLOGS: `${BASE_URL}/getBlogs`,
  QA: `${BASE_URL}/getQA`,
  MAIN_MENU: `${BASE_URL}/getMainMenu`,
  FOOTER_MENU: `${BASE_URL}/getFooterMenu`,
  SPECIALITIES: `${BASE_URL}/getHomeTopSpecialities`,
  CATEGORIES:`https://medizenapi.ir/v1/category/getCategories`,
};
